import {useState, useEffect, PropsWithChildren, FC} from 'react';

type Props = {
  delayInMs?: number;
};

export const DelayedLoadingContainer: FC<PropsWithChildren<Props>> = ({
  delayInMs = 500,
  children,
}) => {
  const [showContent, setShowContent] = useState(false);

  useEffect(() => {
    const id = setTimeout(() => {
      setShowContent(true);
    }, delayInMs);

    return () => {
      clearTimeout(id);
    };
  }, [delayInMs]);

  return showContent && children;
};